<template>
    <section class="container">
        <h1>#{{hashtag}} Twitter Hashtag Analytics</h1>
        <br>
        <h2>
            <span class="green-box">FREE</span> Last 24 Hours Stats
        </h2>
        <HashtagStats :class="{'loading-animation': locked['loading-animation']}" :data="stats"/>
        <br>
        <h2>
            <span class="yellow-box">PAID</span> Last 30 Days Full Analytics
            <small class="text-danger">(not included in RiteTag Pro)</small>
        </h2>
        <div v-if="!locked['loading-animation']">
            <div v-if="!locked.locked">
                <p>
                Following report is based on 100% of tweets containing #{{hashtag}} posted
                <span v-if="periods.length>0">from</span>
                <select class="form-control period-select" v-model="selectedPeriod" v-if="periods.length > 0">
                    <option v-for="period in periods" :value="period.uuid">{{period.from}} to {{period.to}}</option>
                </select>
                <strong v-if="periods.length === 0">from {{data.total ? data.total.from : ''}} to {{data.total ? data.total.to : ''}}</strong>
                    UTC
                </p>
                <p>
                    <a href="https://help.ritekit.com/en/article/how-to-download-a-hashtag-report-as-a-pdf-file-gknsbo/" class="btn btn-primary" target="blank">Download full report in PDF</a>
                </p>
            </div>
            <div v-else>
                <p>
                    Purchase a report <strong>based on 100% of tweets</strong> with #{{hashtag}} posted in the last 30 days.
                </p>
                <p>
                    <a @click="showPriceModal" class="btn btn-upgrade">Calculate price</a>&nbsp;&nbsp;&nbsp;
                    <a class="btn btn-default" href="/hashtag-stats/TNW2019?uuid=4073be07-a7ac-4559-9fde-a31e92e9e211" target="_blank">View sample report</a>
                </p>
            </div>
        </div>
        <Total :class="locked" :data="getData('total')"/>

        <div>
            <data-panel
                    :class="locked"
                    type="accounts"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('accounts')"
                    :links="[]"
                    btn-type="btn-primary">
                <h3>All Accounts ({{getCount('accounts')}})</h3>
                <div class="table-responsive">
                    <table class="table fading">
                        <thead>
                        <tr>
                            <th>Account</th>
                            <th>Bio</th>
                            <th>Followers</th>
                            <th>Tweets</th>
                            <th>Sentiment</th>
                            <th>Language</th>
                            <th>Geo</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="account in getData('accounts')">
                            <td>@{{account.user_name}}</td>
                            <td>{{account.bio}}</td>
                            <td>{{account.followers}}</td>
                            <td>{{account.tweets}}</td>
                            <td>{{account.sentiment | round(2) }}</td>
                            <td>{{account.language}}</td>
                            <td>{{account.location}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </data-panel>
        </div>

        <div>
            <data-panel
                    :class="locked"
                    type="tweets"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('tweets')"
                    :links="[]"
                    btn-type="btn-primary">
                <h3>All Tweets ({{getCount('tweets')}})</h3>
                <div class="table-responsive">
                    <table class="table fading">
                        <thead>
                        <tr>
                            <th class="small-width">Date</th>
                            <th>Account</th>
                            <th>TweetID*</th>
                            <th>Lang</th>
                            <th>Geo</th>
                            <th>Sentiment</th>
                            <th>Likes</th>
                            <th>Retweets</th>
                            <th>Replies</th>
                            <th>Link Domain</th>
                            <th>Photos</th>
                            <th>Videos</th>
                            <th>Live Stream</th>
                            <th>Mentions</th>
                            <th class="hashtag-width">Hashtags</th>
                            <th>Positive adjectives</th>
                            <th>Negative adjectives</th>
                            <th class="emoji-width">Emoji</th>
                            <th>Spelling</th>
                            <th>App</th>
                            <th>Retweet</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="tweet in getData('tweets')">
                            <td>{{tweet.date | formatDate}}</td>
                            <td><a :href="'https://twitter.com/'+tweet.account" target="_blank">@{{tweet.account}}</a></td>
                            <td>{{tweet.tweetId}}</td>
                            <td>{{tweet.lang}}</td>
                            <td>{{tweet.location}}</td>
                            <td>{{tweet.sentiment | round(2) }}</td>
                            <td>{{tweet.likes}}</td>
                            <td>{{tweet.retweets}}</td>
                            <td>{{tweet.replies}}</td>
                            <td>{{tweet.link_domain}}</td>
                            <td>{{tweet.photos}}</td>
                            <td>{{tweet.videos}}</td>
                            <td>{{tweet.live_stream}}</td>
                            <td>{{tweet.mentions.map(x=> '@' + x.screen_name).join(', ')}}</td>
                            <td>{{tweet.hashtags.map(x=> '#' + x).join(', ')}}</td>
                            <td>{{tweet.positive_adjectives.join(', ')}}</td>
                            <td>{{tweet.negative_adjectives.join(', ')}}</td>
                            <td>{{tweet.emoji.join(' ')}}</td>
                            <td>{{tweet.spelling}}</td>
                            <td>{{tweet.app}}</td>
                            <td>{{tweet.is_retweet ? 'Yes' : 'No'}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </data-panel>
        </div>
        <small>
            * Twitter API Terms do not allow us to provide full text of a tweet. You can use free Twitter API to
            retrieve them using Tweet ID.
        </small>

        <div class="page-break-before"></div>
        <div class="flex-wrapper" :class="{'hide': !existsData('sentiment_groups') || getCount('sentiment_groups') == 0}">
            <data-panel
                        :class="locked"
                    type="sentiment_groups"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('sentiment_groups')">
                <h3>Sentiment analysis of tweets with #{{hashtag}}</h3>
                <SentimentHistory :data="getData('sentiment_groups')"/>
            </data-panel>
        </div>

        <div class="flex-wrapper">
            <data-panel
                    :class="locked"
                    type="history"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('history')">
                <h3>How usage of #{{hashtag}} changed over time?</h3>
                <History :data="getData('history')"/>
            </data-panel>

            <data-panel
                    :class="locked"
                    type="hourly_stats"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('hourlyStats')">
                <h3>Which times and day of the week worked the best?</h3>
                <Heatmap :data="getData('hourlyStats')"/>
            </data-panel>
        </div>
        <div class="page-break-before"></div>
        <div class="flex-wrapper">
            <data-panel
                    :class="hideMerge(getCount('supported') == 0)"
                    type="supported"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('supported')">
                <h3>Who supported #{{hashtag}} the most?</h3>
                <Accounts :accounts="getData('supported')" type="sentiment"/>
            </data-panel>

            <data-panel
                    :class="hideMerge(getCount('complained') == 0)"
                    type="complained"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('complained')">
                <h3>Who complained about #{{hashtag}} the most?</h3>
                <Accounts :accounts="getData('complained')" type="sentiment"/>
            </data-panel>
            <data-panel
                    :class="locked"
                    type="mentioned"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('mentioned')">
                <h3>Who was @mentioned the most in the tweets?</h3>
                <Accounts :accounts="getData('mentioned')" type="mentioned"/>
            </data-panel>
            <data-panel
                    :class="locked"
                    type="biggest"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('biggest')">
                <h3>What are the biggest accounts that used #{{hashtag}}?</h3>
                <Accounts :accounts="getData('biggest')" type="biggest"/>
            </data-panel>
        </div>
        <div class="page-break-before"></div>
        <div class="flex-wrapper">
            <data-panel
                    :class="locked"
                    type="countries"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('countries')">
                <h3>How far #{{hashtag}} reached?</h3>
                <CountryChart
                    :chartData="getData('countries')"/>
            </data-panel>
            <data-panel
                    :class="locked"
                    type="languages"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('languages')">
                <h3>Which languages were used in tweets with #{{hashtag}}</h3>
                <BarChart
                        :data="getData('languages')"
                        label="Languages"
                        background-color="rgba(115, 225, 243, 0.9)"
                        border-color="rgba(115, 225, 243, 1)"
                        unit="%"
                />
            </data-panel>
            <data-panel
                    :class="locked"
                    type="sentiment"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('sentiment')">
                <h3>How positive or negative were the tweets?</h3>
                <Histogram :chartData="getData('sentiment')"/>
            </data-panel>
            <data-panel
                    :class="locked"
                    type="emoji"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('emoji')">
                <h3>Which emojis were used the most?</h3>
                <vue-word-cloud
                        class="fixed-word-cloud"
                        :words="getData('emoji')"
                        :color="color"
                        font-family="Baloo Bhaijaan"
                        :fontSizeRatio="4"
                        :spacing="0.5"
                        :animationDuration="0"
                ></vue-word-cloud>
            </data-panel>
        </div>
        <div class="page-break-before"></div>
        <div class="flex-wrapper">
            <data-panel
                    :class="hideMerge(getCount('positiveAdjectives') === 0)"
                    type="positive_adjectives"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('positiveAdjectives')">
                <h3>Which positive adjectives were used the most?</h3>
                <vue-word-cloud
                        class="word-cloud"
                        :words="getData('positiveAdjectives')"
                        :color="color"
                        font-family="Lato"
                        :fontSizeRatio="4"
                        :spacing="0.5"
                        :animationDuration="0"
                ></vue-word-cloud>
            </data-panel>
            <data-panel
                    :class="hideMerge(getCount('negativeAdjectives') === 0)"
                    type="negative_adjectives"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('negativeAdjectives')">
                <h3>Which negative adjectives were used the most?</h3>
                <vue-word-cloud
                        class="word-cloud"
                        :words="getData('negativeAdjectives')"
                        :color="color"
                        font-family="Lato"
                        :fontSizeRatio="4"
                        :spacing="0.5"
                        :animationDuration="0"
                ></vue-word-cloud>
            </data-panel>
            <data-panel
                    :class="locked"
                    type="domains"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('domains')">
                <h3>Which domains were shared the most with #{{hashtag}}?</h3>
                <BarChart
                        :data="getData('domains')"
                        label="Domains"
                        background-color="rgba(115, 243, 171, 0.9)"
                        border-color="rgba(115, 243, 171, 1)"
                        unit="x"
                />
            </data-panel>
            <data-panel
                    :class="locked"
                    type="apps"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('apps')">
                <h3>Which apps were used for tweeting about #{{hashtag}}?</h3>
                <BarChart
                        :data="getData('apps')"
                        label="Apps"
                        background-color="rgba(243, 115, 169, 0.9)"
                        border-color="rgba(243, 115, 169, 1)"
                        unit="%"
                />
            </data-panel>
        </div>
        <div class="page-break-before"></div>
        <div class="flex-wrapper">
            <data-panel
                    :class="locked"
                    type="hashtags"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('hashtags')">
                <h3>Which hashtags were used along with #{{hashtag}}?</h3>
                <HashtagTree :hashtags="getData('hashtags', {})"/>
            </data-panel>
            <data-panel
                    :class="locked"
                    type="spelling"
                    :links="[]"
                    :hashtag="hashtag"
                    :uuid="uuid"
                    :count="getCount('spelling')">
                <h3>How was #{{hashtag}} spelled?</h3>
                <BarChart
                        :data="getData('spelling')"
                        label="Apps"
                        background-color="rgba(243, 227, 115, 0.9)"
                        border-color="rgba(243, 227, 115, 1)"
                        unit="%"
                />
            </data-panel>
        </div>

        <Tweets :locked="locked" :tweets="tw" :hashtag="hashtag"/>
        <price-modal :hashtag="hashtag" ref="priceModal"/>
        <ReportsBanner />
    </section>
</template>
<script>
    import Vue from 'vue'
    import axios from 'axios'
    import Chance from 'chance'
    import _ from 'lodash'

    // import $ from 'jquery'
    // import 'bootstrap-sass/assets/javascripts/bootstrap'
    import VueWordCloud from 'vuewordcloud'

    import Total from '../components/Total'
    import DataPanel from '../components/DataPanel'
    import History from '../components/History'
    import SentimentHistory from '../components/SentimentHistory'
    import Heatmap from '../components/Heatmap'
    import Accounts from '../components/Accounts'
    import CountryChart from '../components/CountryChart'
    import BarChart from '../components/BarChart'
    import Histogram from '../components/Histogram'
    import HashtagTree from '../components/HashtagTree'
    import Tweets from '../components/Tweets'
    import HashtagStats from '../components/HashtagStats'
    import ReportsBanner from '../components/ReportsBanner'

    import PriceModal from '../components/PriceModal'

    const chance = new Chance()

    export default {
        name: 'hashtag-report',
        components: {
            HashtagStats,
            Total,
            DataPanel,
            History,
            Heatmap,
            Accounts,
            CountryChart,
            BarChart,
            Histogram,
            VueWordCloud,
            HashtagTree,
            Tweets,
            PriceModal,
            ReportsBanner,
            SentimentHistory
        },
        data () {
            return {
                hashtag: this.$parent.hashtag,
                total: {},
                stats: {},
                data: {},
                tw: {},
                openPriceModal: false,
                periods: 0,
                selectedPeriod: null,
                locked: {locked: false, 'loading-animation': true},
                uuid: ''
            }
        },
        computed: {

        },
        methods: {
            color ([, weight]) {
                const colors = ['#ffd077', '#3bc4c7', '#3a9eea', '#ff4e69', '#461e47']
                return chance.pickone(colors)
                // return weight > 10 ? 'DeepPink' : weight > 5 ? 'RoyalBlue' : 'Indigo'
            },
            existsData (type) {
                return !!this.data[type]
            },
            getData (type, def = []) {
                if (this.data[type]) {
                    return this.data[type].data
                } else {
                    return def
                }
            },
            getCount (type) {
                if (this.data[type]) {
                    return this.data[type].count
                } else {
                    return 0
                }
            },
            showPriceModal () {
                if (this.$parent.loggedIn) {
                    this.$refs.priceModal.open()
                } else {
                    // eslint-disable-next-line
                    $('#signUpLoginModal').modal('show')
                }
            },
            hideMerge (hide) {
                const obj = _.clone(this.locked)
                return _.merge(obj, {hide: hide})
            }
        },
        created () {
            if (!this.$parent.uuid) {
                this.locked.locked = this.$parent.uuid
            } else {
                this.selectedPeriod = this.$parent.uuid
                this.uuid = this.$parent.uuid
            }
            this.$on('unlock', () => {
                this.showPriceModal()
            })
            axios.get('/api/v2/report/data/' + this.hashtag, {params: {uuid: this.$parent.uuid}})
                .then(resp => {
                    this.data = resp.data.data
                    this.locked.locked = resp.data.locked
                    this.locked['loading-animation'] = false
                    Vue.nextTick()
                        .then(() => {
                            this.tw = this.data.tweets.tw
                            this.stats = this.data.stats
                            this.periods = this.data.periods
                            this.hashtag = this.data.name
                        })
                })
        }
    }
</script>

<style scoped lang="scss">
    .green-box {
        background-color: #5cb85c;
        color: white;
        padding: 4px 8px;
        font-size: 0.7em;
    }
    .yellow-box {
        background-color: #FFDC4E;
        color: white;
        padding: 4px 8px;
        font-size: 0.7em;
    }
    .flex-wrapper {
        display: flex;
        flex-wrap: wrap;
    }
    .period-select {
        display: inline-block;
        width: 225px;
    }
    .small-width {
        min-width: 140px;
    }
    .hashtag-width {
        min-width: 250px;
    }
    .emoji-width {
        min-width: 100px;
    }
    .fixed-word-cloud {
        height: 200px !important;
    }
    .word-cloud {
        height: 300px !important;
    }
</style>



// WEBPACK FOOTER //
// src/ritetag/HashtagReport.vue